import { HtmlParser } from '@calendly/html-parser';
import { I18n } from '@calendly/i18n';
import { Icon } from '@calendly/ui/components/icon';
import { MinimalButton } from '@calendly/ui/components/minimal-button';
import { BodyText } from '@calendly/ui/components/typography';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { useToggleState } from 'hooks/useToggleState';
import { MembersTable } from '../slug_conflict';
import { Marker } from './styles';
const containerCss = "c1yd0lhi";
const Container = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(containerCss, props.className)} />;
});
const headerCss = "hfyxe7v";
const Header = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(headerCss, props.className)} />;
});
const titleCss = "t2udbrv";
const Title = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(titleCss, props.className)} />;
});
const slugCss = "shs8w5i";
const Slug = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(slugCss, props.className)} />;
});
const bodyCss = "bv9uryz";
const Body = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(bodyCss, props.className)} />;
});
const arrowIconIsExpandedCss = "a1e6ugjd";
const arrowIconCss = "a1tdbmrw";
const ArrowIcon = forwardRef((props, ref) => {
  const {
    isExpanded,
    ...restProps
  } = props;
  const name = isExpanded ? 'arrow-down-fill' : 'arrow-left-fill';
  return <Icon ref={ref} {...restProps} name={name} className={classNames(arrowIconCss, {
    [arrowIconIsExpandedCss]: isExpanded
  }, props.className)} />;
});
export const EventTypeCard = ({
  managedEvent,
  memberships
}) => {
  const [isExpanded, toggleExpanded] = useToggleState(false);
  return <Container key={managedEvent.id}>
      <Header>
        <Marker color={managedEvent.color} />
        <Title>
          <BodyText weight="bold">
            {managedEvent.name}
          </BodyText>
        </Title>
        <Slug>
          <BodyText>
            /
            {managedEvent.slug}
          </BodyText>
        </Slug>
        <MinimalButton fontSize="medium" onClick={toggleExpanded}>
          {I18n.t('publisher.organization.members.bulk_managed_events_applying.slug_conflict.details')}
        </MinimalButton>
        <ArrowIcon isExpanded={isExpanded} />
      </Header>
      {isExpanded && <Body>
          <BodyText>
            {HtmlParser(I18n.t('publisher.organization.members.bulk_managed_events_applying.slug_conflict.description', {
          count: memberships.length,
          slug: managedEvent.slug
        }))}
          </BodyText>
          <MembersTable memberships={memberships} />
        </Body>}
    </Container>;
};

require("./event_type_card.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./event_type_card.js");